function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { POLICY_COUNTERS_EDIT_ACCESS } from '../../../../../../security.attributes';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
var PolicyCountersController = /*#__PURE__*/function () {
  function PolicyCountersController($ngRedux, $timeout) {
    _classCallCheck(this, PolicyCountersController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      handleMoreOptionsSelected: this.handleMoreOptionsSelected.bind(this),
      onCollapse: this.onCollapse.bind(this)
    });
  }
  return _createClass(PolicyCountersController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {};
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      this.moreMenuItems = [{
        id: CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_POLICY_COUNTER_MODAL.TITLE,
        title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_POLICY_COUNTER_MODAL.TITLE)
      }];
      this.editPolicyCounterModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.handleEditPolicyCounterModalConfig = event.api;
        }
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "hasPolicyCountersEditAccess",
    value: function hasPolicyCountersEditAccess() {
      return hasAccess(this.state.userSecurityAttributes, POLICY_COUNTERS_EDIT_ACCESS);
    }
  }, {
    key: "handleMoreOptionsSelected",
    value: function handleMoreOptionsSelected(_ref) {
      var item = _ref.item;
      switch (item.id) {
        case CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_POLICY_COUNTER_MODAL.TITLE:
          this.openEditPolicyCounterModal();
          break;
        default:
          break;
      }
    }
  }, {
    key: "openEditPolicyCounterModal",
    value: function openEditPolicyCounterModal() {
      var _this2 = this;
      this.isEditPolicyCounterModalOpen = true;
      this.$timeout(function () {
        _this2.handleEditPolicyCounterModalConfig.open();
      });
    }
  }, {
    key: "closeEditPolicyCounterModal",
    value: function closeEditPolicyCounterModal() {
      this.isEditPolicyCounterModalOpen = false;
      this.handleEditPolicyCounterModalConfig.close();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onCollapse",
    value: function onCollapse() {
      return function () {};
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&',
    policyCounters: '<?',
    serviceIdentifier: '<'
  },
  controller: PolicyCountersController,
  controllerAs: 'PolicyCountersController',
  template: require('./policy.counters.template.html')
};